import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import { HOTEL_RESULTS_V2_QUICK_FILTERS } from "../constants";
import type { HotelResultsV2QuickFilterKey } from "../types";

interface QuickFiltersProps {
  activeQuickFilters: string[];
  splitAfterFirst?: boolean;
  onToggle: (key: HotelResultsV2QuickFilterKey) => void;
}

export default function QuickFilters({
  activeQuickFilters,
  splitAfterFirst,
  onToggle,
}: QuickFiltersProps) {
  const quickFilters = splitAfterFirst
    ? HOTEL_RESULTS_V2_QUICK_FILTERS
    : HOTEL_RESULTS_V2_QUICK_FILTERS;

  return (
    <div className="flex shrink-0 snap-x items-center gap-2 md:flex-1 md:flex-wrap">
      {quickFilters.map((quickFilter, index) => {
        const active = activeQuickFilters.includes(quickFilter.key);

        return (
          <button
            key={quickFilter.key}
            onClick={() => onToggle(quickFilter.key)}
            className={`inline-flex shrink-0 snap-start items-center gap-1.5 rounded-full border px-3.5 py-2 text-[13px] font-semibold leading-none transition-all ${
              splitAfterFirst && index > 0 ? "max-md:hidden" : ""
            } ${
              active
                ? "border-transparent bg-[#e84040] text-white"
                : quickFilter.featured
                  ? "border-[#e84040] bg-white text-[#e84040] shadow-[0_0_0_2px_rgba(232,64,64,0.08)]"
                  : "border-slate-200 bg-white text-slate-950 hover:border-primary hover:text-primary"
            }`}
            type="button"
          >
            <PhosphorIcon name={quickFilter.icon} size={13} />
            {quickFilter.label}
          </button>
        );
      })}
    </div>
  );
}

export function SecondaryQuickFilters({
  activeQuickFilters,
  onToggle,
}: QuickFiltersProps) {
  return (
    <div className="flex shrink-0 snap-x items-center gap-2 md:hidden">
      {HOTEL_RESULTS_V2_QUICK_FILTERS.slice(1).map((quickFilter) => {
        const active = activeQuickFilters.includes(quickFilter.key);

        return (
          <button
            key={quickFilter.key}
            onClick={() => onToggle(quickFilter.key)}
            className={`inline-flex shrink-0 snap-start items-center gap-1.5 rounded-full border px-3.5 py-2 text-[13px] font-semibold leading-none transition-all ${
              active
                ? "border-transparent bg-[#e84040] text-white"
                : "border-slate-200 bg-white text-slate-950 hover:border-primary hover:text-primary"
            }`}
            type="button"
          >
            <PhosphorIcon name={quickFilter.icon} size={13} />
            {quickFilter.label}
          </button>
        );
      })}
    </div>
  );
}
